/**
 * EmissionsTable — avoided emissions with optional Floor / Ceiling columns.
 * Central is the run's avoided quantity; Floor/Ceiling apply the uniform
 * realization ratio derived from the endpoint sweep (generation is fixed, so
 * every avoided quantity scales ~linearly with realized displacement).
 */

export interface EmissionRow {
  substance: string;
  centralText: string;
  floorText?: string;
  ceilingText?: string;
  unit: string;
}

export function EmissionsTable({
  rows,
  showRange,
  lensLabel,
}: {
  rows: EmissionRow[];
  showRange: boolean;
  lensLabel: string;
}) {
  return (
    <div className="card" style={{ margin: 0 }}>
      <div className="ch">
        <h2>Emissions avoided</h2>
        <span className="mut">{lensLabel}</span>
      </div>
      <div className="cb" style={{ paddingTop: 6, overflowX: "auto" }}>
        {rows.length === 0 ? (
          <div className="empty">No emissions data for this run.</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Substance</th>
                <th className="num">Central</th>
                {showRange && <th className="num">Floor</th>}
                {showRange && <th className="num">Ceiling</th>}
                <th>Unit</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.substance}>
                  <td>{r.substance}</td>
                  <td className="num">{r.centralText}</td>
                  {showRange && <td className="num">{r.floorText ?? "—"}</td>}
                  {showRange && <td className="num">{r.ceilingText ?? "—"}</td>}
                  <td>{r.unit}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
